import React from "react";
import classnames from "classnames";
import "./toggle.scss";

function ToggleInput({
  value,
  onChange,
  className,
  palette = [],
  label = "",
  resetValue,
  isResponsive = false,
  valueTablet,
  setValueTablet,
  resetValueTablet,
  valueMobile,
  setValueMobile,
  resetValueMobile,
  reverseLayout = false,
  sameBGColorAfterToggle = false,
}) {
  if (value === undefined || value === null) {
    value = false;
  }

  const classes = classnames(
    `grigora-toggle-input-ui-kit text-grigora-base mb-2 flex ${
      reverseLayout ? "flex-row-reverse" : ""
    } items-center select-none justify-end gap-2`,
    className,
  );

  return (
    <div className={classes}>
      {label && <div className="text-grigora-base flex flex-1">{label}</div>}
      <div className="flex items-center text-white gap-2">
        <label className="switch">
          <input
            type="checkbox"
            checked={!!value}
            onChange={(e) => {
              onChange(e.target.checked);
            }}
          />
          <span
            className={`slider round ${
              sameBGColorAfterToggle ? "prevent-background-change" : ""
            }`}
          ></span>
        </label>
      </div>
    </div>
  );
}

export default ToggleInput;
